// extracted by mini-css-extract-plugin
export default {"AppLink":"AppLink--1OgJt"};